// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__25b3I","title":"FrontImage_title__38p2Q"};